"use strict";

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Represents an object or resource in the Polymath Ecosystem with its own set of properties and functionality
 */

var Entity = function Entity() {
  _classCallCheck(this, Entity);
};

exports.Entity = Entity;